import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { authLogout } from '../../../../../actions/AuthActions';
import OtherClickListener from '../../../../../events/OtherClickListener';
import { propStr, propShape, propFunc, propBool, propChildren, } from '../../../../../helpers/custom-prop-types';
import PersonIcon from '../../../../Icon/Svg/PersonIcon';
import SlideSearchHeaderSideMenuPc from './Pc';
import SlideSearchHeaderSideMenuSp from './Sp';
const SlideSearchHeaderSideMenu = (props) => {
    const { actionButtonProps, className, hideMenu, isShowMenu, links, planComponent, profile, toggleMenu, } = props;
    const dispatch = useDispatch();
    const ref = useRef();
    const onClickLogout = useCallback(() => {
        dispatch(authLogout());
    }, [dispatch]);
    useEffect(() => {
        const index = OtherClickListener.setListener(ref.current, hideMenu);
        return () => {
            OtherClickListener.deleteListener(index);
        };
    }, [ref, hideMenu]);
    return (_jsxs("div", Object.assign({ className: `slide_search_header_side_menu ${className}`, ref: ref }, { children: [_jsxs("button", Object.assign({ className: 'profile_button', onClick: toggleMenu, type: 'button' }, { children: [_jsx("div", Object.assign({ className: 'button_left' }, { children: _jsx(PersonIcon, { className: 'left_icon' }) })), _jsx(CloseIcon, { className: clsx('button_right', !isShowMenu && 'is-dnone-important') }), _jsx(MenuIcon, { className: clsx('button_right', isShowMenu && 'is-dnone-important') })] })), _jsx(SlideSearchHeaderSideMenuPc, { isShow: isShowMenu, onClickLogout: onClickLogout, profile: profile }), _jsx(SlideSearchHeaderSideMenuSp, { actionButtonProps: actionButtonProps, hideMenu: hideMenu, isShow: isShowMenu, links: links, onClickLogout: onClickLogout, planComponent: planComponent, profile: profile })] })));
};
SlideSearchHeaderSideMenu.propTypes = {
    actionButtonProps: propShape().isRequired,
    className: propStr(),
    hideMenu: propFunc().isRequired,
    isShowMenu: propBool().isRequired,
    links: propShape().isRequired,
    planComponent: propChildren().isRequired,
    profile: propShape().isRequired,
    toggleMenu: propFunc().isRequired,
};
SlideSearchHeaderSideMenu.defaultProps = {
    className: '',
};
export default SlideSearchHeaderSideMenu;
